import NomPrenomDDN from "./NomPrenomDDN";
import styles from "./PatientEntry.module.css";

interface PatientEntryProps {
  birthdate: string;
  name: string;
  forename: string;
  onNameChange: (value: string) => void;
  onForenameChange: (value: string) => void;
  onBirthdateChange: (value: string) => void;
  isValidDdn: boolean;
  isNewPatientMode: boolean;
}

const PatientEntry = (props: PatientEntryProps) => {
  const { isNewPatientMode } = props;
  const phrase = isNewPatientMode
    ? "Caractéristiques du nouveau patient"
    : "Recherche du patient";
  return (
    <div className={styles.row}>
      <span className={styles.question}>{phrase}</span>
      <div className={styles.tab}>
        <NomPrenomDDN {...props} showPrenom={isNewPatientMode} />
      </div>
    </div>
  );
};

export default PatientEntry;
